import { createSlice } from "@reduxjs/toolkit";

import { requestSize } from "../requests/thunks/requestSize";
import { requestSizeUpdate } from "../requests/thunks/requestSizeUpdate";
import { requestDesign_Aggregated } from "../requests/thunks/requestDesign_Aggregated";
import { requestDesignUpdate } from "../requests/thunks/requestDesignUpdate";

const initialState = {
  // (Images.Images accordring to CGE API data structure)
  Images: [],
  CurrentAngle: "",
};

const handleImagesResponse = (state, action) => {
  const { cgeObj } = action.payload;
  const { Images } = cgeObj;

  if (!Images) {
    console.error("Missing expected property Images in ImageSlice");
    return;
  }

  // (Images.Images accordring to CGE API data structure)
  state.Images = Images.Images;
  state.CurrentAngle = Images.CurrentAngle;
};

// NOTE: ImagesSlice is used only in SizeView and DesignView (step 3 and 4)
const ImagesSlice = createSlice({
  name: "ImageSlice",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(requestSize.fulfilled, handleImagesResponse)
      .addCase(requestSizeUpdate.fulfilled, handleImagesResponse)
      .addCase(requestDesign_Aggregated.fulfilled, handleImagesResponse)
      .addCase(requestDesignUpdate.fulfilled, handleImagesResponse);
  },
});

export default ImagesSlice.reducer;
